import React, { Fragment } from 'react';

import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';
import SimpleModal from 'components/modals/simple-modal';
import TraderaLogo from 'components/tradera/logo';
import './gdpr-modal.scss';

const GdprModal = props => {
    const { t } = useTranslator();
    const { openGdprSettings, acceptAndHide } = props;
    return (
        <SimpleModal
            className="site-width"
            classNameBody="gdpr-modal-body bg-info p-5 rounded shadow mw-100 d-flex flex-column"
            closeModalCallback={() => {}}>
            <Fragment>
                <div
                    data-gdpr-modal=""
                    className="flex-grow-1 flex-shrink-1 mb-auto">
                    <h4 className="text-center mt-5">
                        <InfoIcon className="icon icon-lg" />
                    </h4>
                    <h4 className="text-center">
                        <TraderaLogo width={100} />
                    </h4>
                    <h4 className="text-center">
                        {t('gdprConsent_modal_header')}
                    </h4>
                    <hr className="my-4" />
                    <p>
                        {t('gdprConsent_modal_info')}{' '}
                        <a
                            href="#"
                            className="text-primary"
                            onClick={openGdprSettings}>
                            <u>{t('gdprConsent_changeSettings')}</u>
                        </a>
                    </p>
                </div>
                <button
                    data-gdpr-approve-button=""
                    className="btn btn-primary"
                    onClick={() =>
                        acceptAndHide(true, true, true, 'Approve All')
                    }>
                    <CheckIcon className="icon mr-2" />{' '}
                    {t('gdprConsent_approveCookies')}
                </button>
            </Fragment>
        </SimpleModal>
    );
};

export default GdprModal;
